import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import './Modal.css';

export default function ModalLogin({ onClose, onSwitch }) {
  const { login } = useAuth();
  const [form, setForm]     = useState({ email: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const [isForgot, setIsForgot] = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: form.email });
      toast.success('Se ha enviado un enlace a tu correo ✨');
      setIsForgot(false);
    } catch (err) {
      setError(err.response?.data?.msg || 'Error al enviar recuperación');
    } finally { setLoading(false); }
  };

  const submit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success(`¡Bienvenido, ${u.nombre}! 🎉`);
      onClose();
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (err) {
      const msg = err.response?.data?.msg || err.message || 'Error de conexión';
      setError(msg);
    } finally { setLoading(false); }
  };

  return (
    <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal fade-up">
        <button className="modal-close" onClick={onClose}>✕</button>
        {isForgot ? (
          <>
            <h2>Recuperar clave</h2>
            <p className="modal-sub">Enviaremos un enlace a tu correo electrónico</p>
            <form onSubmit={handleForgotSubmit}>
              <div className="f-group">
                <label className="f-lbl">Correo electrónico</label>
                <input className="f-inp" name="email" type="email" placeholder="correo@ejemplo.com" value={form.email} onChange={handle} required />
              </div>
              {error && <p className="f-err mb-3">{error}</p>}
              <button className="btn btn-v btn-full btn-lg" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar enlace'}
              </button>
              <p className="modal-switch mt-4" onClick={() => setIsForgot(false)}>
                Volver al login
              </p>
            </form>
          </>
        ) : (
          <>
            <h2>Bienvenido de vuelta</h2>
            <p className="modal-sub">Inicia sesión en Red Cimarrona</p>

            <form onSubmit={submit}>
              <div className="f-group">
                <label className="f-lbl">Correo electrónico</label>
                <input className="f-inp" name="email" type="email" placeholder="correo@ejemplo.com" value={form.email} onChange={handle} required />
              </div>
              <div className="f-group">
                <div className="flex justify-between items-baseline">
                  <label className="f-lbl">Contraseña</label>
                  <span className="modal-switch text-[11px]" onClick={() => setIsForgot(true)}>¿Olvidaste tu clave?</span>
                </div>
                <input className="f-inp" name="password" type="password" placeholder="••••••••" value={form.password} onChange={handle} required />
              </div>
              {error && <p className="f-err mb-3">{error}</p>}
              <button className="btn btn-v btn-full btn-lg" disabled={loading}>
                {loading ? 'Entrando...' : 'Iniciar sesión'}
              </button>
            </form>

            <p className="modal-switch">
              ¿No tienes cuenta? <span onClick={onSwitch}>Regístrate</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
